
window.options.personalisationOptions.loadingSpinner.width = 50;
window.options.personalisationOptions.loadingSpinner.height = 50;

window.options.slickOptions.slidesToShow = 3;
window.options.slickOptions.slidesToScroll = 3;

window.options.slickOptions.slidesToShow_Wallet = 3;
window.options.slickOptions.slidesToScroll_Wallet = 3;

window.options.slickOptions.slidesToShow_Tablet = 2;
window.options.slickOptions.slidesToScroll_Tablet = 2;

window.options.slickOptions.slidesToShow_Mobile = 1;
window.options.slickOptions.slidesToScroll_Mobile = 1;
